
const getIsDataFetched = state => state.chart.isDataFetched;

export default getIsDataFetched;
